import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view03ImageOptions } from './views/exterior_view03'

class X40HullTreatment extends Component {
    constructor(props) {
        super(props);
        this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this);
    }


    handleHullTreatmentChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullTreatment = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view03ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.67}  name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.047038, -0.022728, 0, -0.000027,
                    -0.012508, 0.071564, 0, -0.000025,
                    0, 0, 1, 0,
                    201, 157, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Hull Treatment' /></h1>

                    <p><Trans defaults='3 layers of sprayed epoxy primer &amp; 2 layers of antifouling paint' /></p>

                    <RadioGroup label={this.props.t("Treatment options:")} options={this.props.hullTreatmentOptions} value={this.props.configuration.HullTreatment} onChange={this.handleHullTreatmentChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40HullTreatment);


// WEBPACK FOOTER //
// ./src/X40/X40HullTreatment.js